import { KbGuidePage } from "@/components/kb/KbGuidePage";

export function Guide003SocialMediaContentIdeas() {
  return <KbGuidePage slug="guide-003-social-media-content-ideas" />;
}

(Guide003SocialMediaContentIdeas as unknown as { path: string }).path = "/guides/social-media-content-ideas";
